import "./App.css";
import React from "react";
import DashBoardPanel from "pages/dashboard/Dashboard";
import Notification from "pages/dashboard/Notification";

const DEV_URL = "https://dev-mocawsedge.in"
const QA_URL = "https://qa-mocawsedge.in"
const PROD_URL = "https://www.v1.moc.net.in"

const CognitoOTPApp = () => {

  const isProd = process.env.REACT_APP_WEB_API === PROD_URL

  const generateEnvHeader = () => {
    let cardCss = "bg-success-subtle text-success-emphasis"
    let environment = "Local"
    if (process.env.REACT_APP_WEB_API === DEV_URL) {
      cardCss = "bg-info-subtle text-info-emphasis"
      environment = "DEV"
    } else if (process.env.REACT_APP_WEB_API === QA_URL) {
      cardCss = "bg-warning-subtle text-warning-emphasis"
      environment = "QA"
    } else if (process.env.REACT_APP_WEB_API === PROD_URL) {
      cardCss = "bg-danger-subtle text-danger-emphasis"
      environment = "OLD PROD"
    }
    return (
      <div className={`text-center p-2 ${cardCss} text-white sticky-top`} style={{ zIndex: 1005 }}>
        <div>Deprecated Software - {environment} Environment</div>
      </div>
    )
  }

  return (
    <>
      {!isProd && generateEnvHeader()}
      <DashBoardPanel envHeaderEnabled={!isProd} />
      <Notification />
    </>

  )

}

export default CognitoOTPApp

